var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sn-page sn-assembly sn-f-c-c toast-page"},[_c('div',{staticClass:"sn-f-col-c-c toast-blank"},[_c('div',{staticClass:"toast-caption"},[_vm._v(_vm._s(_vm.option.caption))])])])}
var staticRenderFns = []

export { render, staticRenderFns }